import Repository from "../axios";
import { defaultPagination } from "@/constants/config";
const resource = "/admin/quality-controls";

export default {
  getListOfQualityControlTestings(filterQuery = "", pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${resource}/tastings?${filterQuery}&paginate=${pagination}&page=${pageNumber}`);
  },
  getListOfQualityControlTestingsGroupByType(filterQuery = "", pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${resource}/tastings/grouped-by-types?${filterQuery}&paginate=${pagination}&page=${pageNumber}`);
  },
  getListOfStatuses() {
    return Repository.get(`${resource}/tastings/statuses`);
  },
  getListOfTypes() {
    return Repository.get(`${resource}/tastings/types`);
  },
  getListOfPropertyTypes() {
    return Repository.get(`${resource}/tastings/property-statuses`);
  },
  createQualityControlTestings(payload){
    return Repository.post(`${resource}/tastings/`, payload);
  },
  updateQualityControlTestings(id,payload){
    return Repository.put(`${resource}/tastings/${id}`, payload);
  },
  getQualityControlTestDetails(id){
    return Repository.get(`${resource}/tastings/${id}`)
  },
  getTriangleTestList(filterQuery = "", pageNumber = 1, pagination = defaultPagination){
    return Repository.get(`${resource}/triangle-tests?${filterQuery}&paginate=${pagination}&page=${pageNumber}`)
  },
  getTriangleTestDetails(id){
    return Repository.get(`${resource}/triangle-tests/${id}`)
  },
  getRandomWo(formulation_id){
    return Repository.get(`${resource}/triangle-tests/formulations/${formulation_id}/work-orders`)
  },
  createTriangleTest(payload){
    return Repository.post(`${resource}/triangle-tests`, payload)
  },
  updateTriangleTest(id,payload){
    return Repository.put(`${resource}/triangle-tests/${id}`, payload)
  },
  getTriangleTestStatusList(){
    return Repository.get(`${resource}/triangle-tests/statuses`)
  },
  getFormTestingStatusList(){
    return Repository.get(`${resource}/tastings/statuses`)
  },
  updateTriangleTestStatus(id, payload){
    return Repository.put(`${resource}/triangle-tests/${id}/status`, payload)
  },
  updateFormTestingStatus(id, payload){
    return Repository.put(`${resource}/tastings/${id}/status`, payload)
  },

  //Tasting Groups

  getListOfTastingGroups(filterQuery = "", pageNumber = 1, pagination = defaultPagination){
    return Repository.get(`${resource}/tastings/groups?${filterQuery}&paginate=${pagination}&page=${pageNumber}`)
  },
  createTastingGroup(payload){
    return Repository.post(`${resource}/tastings/groups`, payload)
  },
  getTastingGroup(id){
    return Repository.get(`${resource}/tastings/groups/${id}`)
  },
  updateTastingGroup(id,payload){
    return Repository.put(`${resource}/tastings/groups/${id}`, payload)
  },
  getListOfGroupStatuses() {
    return Repository.get(`${resource}/tastings/groups/statuses`);
  },
  updateTastingGroupStatus(id, payload){
    return Repository.put(`${resource}/tastings/groups/${id}/status`, payload)
  },
  getTastingGroupsAssignedToUser(filterQuery = "", pageNumber = 1, pagination = defaultPagination){
    return Repository.get(`${resource}/tastings/groups/me?${filterQuery}&paginate=${pagination}&page=${pageNumber}`)
  },
  getTastingGroupResult(id){
    return Repository.get(`${resource}/tastings/groups/${id}`)
  },

  //Tasting groups sign off


  getListOfSignOffStatuses(){
    return Repository.get(`${resource}/tastings/groups/sign-off/statuses`)
  },

  signOffTastingGroup(id, payload){
    return Repository.post(`${resource}/tastings/groups/${id}/sign-off`, payload)
  },

  getTastingGroupSignOff(id, batch_type, batch_id){
    return Repository.get(`${resource}/tastings/groups/${id}/sign-off?batch_type=${batch_type}&batch_id=${batch_id}`)
  },
  
  getListOfTastingGroupSignOffStatuses() {
    return Repository.get(`${resource}/tastings/groups/sign-off/statuses`);
  },
  
  createTastingGroupSignOff(id, payload){
    return Repository.post(`${resource}/tastings/groups/${id}/sign-off`, payload)
  },

  cloneTastingGroup(id){
    return Repository.post(`${resource}/tastings/groups/${id}/clone`)
  },

  //history

  getLastTestForBatch(batch_id, batch_type){
    return Repository.get(`${resource}/tastings/get-latest-test?id=${batch_id}&type=${batch_type}`)
  },

  //export
  exportTastingGroupPdf(id){
    return Repository.get(`${resource}/tastings/groups/${id}/get-pdf`, { responseType: 'blob' })
  },

  //tasting group file upload
  updateTastingGroupFiles(id, payload){
    return Repository.put(`${resource}/tastings/groups/${id}/file-paths`, payload)
  },
  getTastingGroupFiles(id){
    return Repository.get(`${resource}/tastings/groups/${id}/file-paths`)
  },
  

};
